import httpService from '@/modules/common/services/httpService';
import { resolveDynamicFilterValue } from '@/modules/crm/utils/filterValueResolver';

const viewsRoute = '/business/search/v1/views';
const filtersRoute = '/business/search/v1/view_filters';

const getViews = async () => httpService.get(viewsRoute)
  .then((res) => res.data?.data);

const getFilters = async () => httpService.get(filtersRoute)
  .then((res) => res.data?.data);

const updateViews = async (views) => httpService.post(`${viewsRoute}/bulk`, { views })
  .then((res) => res.data);

const createView = async (view) => httpService.post(`${viewsRoute}`, { view })
  .then((res) => res.data);

const updateView = async (uid, view) => httpService.put(`${viewsRoute}/${uid}`, { view })
  .then((res) => res.data);

const deleteView = async (uid) => httpService.remove(`${viewsRoute}/${uid}`, { uid })
  .then((res) => res.data);

const getAvailableColumns = async () => httpService.get(`${viewsRoute}_columns`)
  .then((res) => res.data?.data);

const getSearchFiltersObjectFromNewDecorationFiltersObject = (filters) => {
  if (!filters) return {};
  const searchFilters = { search_filter: {} };

  filters.forEach((filter) => {
    const resolvedValue = resolveDynamicFilterValue(filter);
    const { key } = filter;
    const isMatterMetadata = key.startsWith('matter_metadata_flat');

    if (filter.type === 'tags') {
      const tagKey = key;
      const { tags, relation } = resolvedValue;

      searchFilters.search_filter[tagKey] = tags.join(',');
      searchFilters.search_filter.tags_relation = relation;
    } else if (key.startsWith('matter_metadata_flat_or') && filter.type === 'multiselect_metadata') {
      const mainKey = 'matter_metadata_flat_or';
      const filterName = key.slice(mainKey.length + 1);
      searchFilters.search_filter[mainKey] = {};

      resolvedValue.forEach((val) => {
        const subKey = `${filterName}.${val}`;
        searchFilters.search_filter[mainKey][subKey] = {range: {gte: 1}};
      });
    } else if (isMatterMetadata) {
      const mainKey = 'matter_metadata_flat';
      const subKey = key.slice(mainKey.length + 1);

      searchFilters.search_filter[mainKey] = {
        ...searchFilters.search_filter[mainKey],
        [subKey]: resolvedValue,
      };
    } else {
      const keys = key.split('.');
      let currentLevel = searchFilters.search_filter;

      keys.forEach((k, index) => {
        if (index === keys.length - 1) {
          currentLevel[k] = resolvedValue;
        } else {
          if (!currentLevel[k]) {
            currentLevel[k] = {};
          }
          currentLevel = currentLevel[k];
        }
      });
    }
  });

  return searchFilters;
};

export default {
  getViews,
  getFilters,
  updateViews,
  createView,
  updateView,
  deleteView,
  getAvailableColumns,
  getSearchFiltersObjectFromNewDecorationFiltersObject,
};
